import * as React from 'react';
import { Dialog as DialogPrimitive } from 'radix-ui';

export type DialogRootProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Root>;
export type DialogTriggerProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Trigger>;
export type DialogPortalProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Portal>;
export type DialogOverlayProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>;
export type DialogContentProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>;
export type DialogTitleProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>;
export type DialogDescriptionProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Description>;
export type DialogCloseProps = React.ComponentPropsWithoutRef<typeof DialogPrimitive.Close>;

const { Root, Trigger, Portal, Overlay, Content, Title, Description, Close } = DialogPrimitive;

Trigger.displayName = 'Dialog.Trigger';
Portal.displayName = 'Dialog.Portal';
Overlay.displayName = 'Dialog.Overlay';
Content.displayName = 'Dialog.Content';
Title.displayName = 'Dialog.Title';
Description.displayName = 'Dialog.Description';
Close.displayName = 'Dialog.Close';

export { Root, Trigger, Portal, Overlay, Content, Title, Description, Close };

const pkg: {
  Root: typeof Root;
  Trigger: typeof Trigger;
  Portal: typeof Portal;
  Overlay: typeof Overlay;
  Content: typeof Content;
  Title: typeof Title;
  Description: typeof Description;
  Close: typeof Close;
} = {
  Root,
  Trigger,
  Portal,
  Overlay,
  Content,
  Title,
  Description,
  Close,
};

export default pkg;
